// extracted by mini-css-extract-plugin
export default {"chip":"BadgeItem_chip__Q1Sb+","icon":"BadgeItem_icon__gkRGM"};